import { readItemField } from '../../compile/item-field-reader';
import type { Row } from '../context';
import { ABILITY_FEATURE_TYPES } from './inventory-status-applicability';

const STATUS_TYPES: ReadonlySet<string> = new Set([...ABILITY_FEATURE_TYPES,
    'creature', 'status_effect', 'disease', 'lair_ability', 'trap_ability']);

/** The browser recorder and independently skippable effects share one status-item contract. */
export function statusCapabilityFailure(definition: Row | null, id: string): string | null {
    if (!definition) return `commit:status-definition-not-held:${id.toUpperCase()}`;
    const type = String(readItemField(definition, 'item_type') ?? '');
    return STATUS_TYPES.has(type) ? null : `commit:status-not-status-capable:${type}`;
}
